/** Eternal City copy, de. Machine assisted from the English, pending review; proper names and {placeholders} kept as in English. NPC dialogue stays English. */
export const cityDe: Record<string, string> = {
  'city.seoDescription': 'Geht in eine lebendige Stadt. Jeder hält eine tägliche Routine ein. Folgt ihnen, redet mit ihnen und verbringt einen Tag bei Menschen, die ohne euch weiterleben.',
  'city.intro': 'Ein lebendiger Stadt. Jeder hier hält eine tägliche Routine und die Zeit vergeht, während Sie spielen.',
  'city.back': 'Zurück zum Globus',
  'city.connecting': 'Die Toren der Stadt zu öffnen...',
  'city.reconnecting': 'Ich habe den Thread verloren.',
  'city.offline': 'Die Stadt ist jetzt außer Reichweite.',
  'city.signinTitle': 'Melden Sie sich an .',
  'city.signinBody': 'Ihr Platz in der Stadt, Ihr Tagebuch und die Menschen, die ihr getroffen habt, sind auf eurem Rechnen gespeichert.',
  'city.signinCta': 'Anmelden Sie sich .',
  'city.privacy': 'Wie wir mit diesen Daten umgehen: Datenschutzerklärung',
  'city.blocked': 'Die Stadt kann dieses Konto nicht eröffnen, wenn Sie das für einen Fehler halten, wenden Sie sich bitte an den Support.',
  'city.openElsewhere': 'Diese Stadt ist in einem anderen Register geöffnet.',
  'city.canvasLabel': 'Isometrische Karte von {city}. Verwenden Sie die Listen neben ihm, um zu reden, zu gehen und sich umzusehen.',
  'city.hint': 'Klicken Sie auf den Boden, um zu gehen, oder klicken Sie auf eine Person, um zu sprechen.',
  'city.holiday': 'Heute: {name}',
  'city.here': 'Sie sind bei {place}.',
  'city.commons.empty': 'Das ist ein gemeinsamer Raum, und keine anderen Reisenden sind gerade hier.',
  'city.commons.here.one': 'Das ist ein gemeinsamer Raum, und ein weiterer Reisender ist hier.',
  'city.commons.here.other': 'Das ist ein gemeinsamer Raum. {count} Andere Reisende sind hier.',
  'city.commons.peer': 'ein Mitreisender',
  'city.crowd.name': 'Stadtbewohner',
  'city.travel.ride': 'Fahren Sie zu {place} (etwa {n} (Durchschnitt)',
  'city.wares.now': 'Jetzt ausgesprochen: {list}',
  'city.wares.none': 'Es gibt nichts zu dieser Zeit.',
  'city.wares.few': '{name} (ein paar links)',
  'city.wares.last': '{name} (die letzte)',
  'city.places': 'Gehen Sie irgendwo hin.',
  'city.goPlace': 'Gehen Sie . {place}',
  'city.dialogueAnnounce': 'Die Wahlen werden angekündigt, wie sie erscheinen.',
  'city.people': 'Wer ist da ?',
  'city.peopleNone': 'Niemand in Sicht.',
  'city.talk': 'Sprechen Sie .',
  'city.goto': 'Gehen Sie vorbei.',
  'city.away': '{n} Schritte weg',
  'city.scenes': 'Das passiert in der Nähe.',
  'city.watch': 'Nehmen Sie an .',
  'city.props': 'Schau dich um .',
  'city.examine': 'Sieh mal .',
  'city.open': 'Öffnen',
  'city.take': 'Nehmen Sie es.',
  'city.menu.open': 'Öffnen {thing}',
  'city.menu.take': 'Nehmen Sie, was drin ist. {thing}',
  'city.menu.walkToThing': 'Gehen Sie zu. {thing}',
  'city.dialogue': 'Gespräch',
  'city.close': 'Schließen',
  'city.leave': 'Lassen Sie das Gespräch',
  'city.menu.talk': 'Sprechen Sie mit {name}',
  'city.menu.walkTalk': 'Gehen Sie zu mir. {name}',
  'city.menu.walkTo': 'Gehen Sie zu. {name}',
  'city.menu.walkHere': 'Geht her.',
  'city.menu.swimHere': 'Schwimmen Sie hier.',
  'city.menu.rowHere': 'Rufen Sie sich hier an.',
  'city.mount.down': 'Steigen Sie ab . {name}',
  'city.companion.home': 'Schicken Sie {name} Zuhause',
  'city.rumours.title': 'Gerüchte-Schild',
  'city.rumours.none': 'Wir stehen in der Nähe der Stadt, die miteinander reden, vor allem in der Taverne, und was sie sagen, ist hier festgehalten.',
  'city.rumours.said': 'Sagte er {name}',
  'city.greet.title': 'Bekannt nach Namen',
  'city.greet.callMe': 'Wie nennen Sie die Stadtbewohner?',
  'city.greet.placeholder': 'Dein Name .',
  'city.greet.none': 'Niemand kennt dich noch. Hör auf, mit jemandem zu sprechen, und das nächste Mal grüßen sie dich mit dem Namen.',
  'city.greet.morning.0': 'Morgen. {name}!',
  'city.greet.morning.1': 'Guten Morgen zu dir. {name}.',
  'city.greet.morning.2': 'Ich bin früh aufgestanden. {name}?',
  'city.greet.afternoon.0': 'Ich habe einen guten Nachmittag. {name}.',
  'city.greet.afternoon.1': 'Guten Tag. {name}!',
  'city.greet.afternoon.2': 'Gut wieder getroffen, {name}.',
  'city.greet.evening.0': 'Am Abend. {name}.',
  'city.greet.evening.1': 'Guten Abend. {name}!',
  'city.greet.evening.2': 'Ich bin weg von zu Hause. {name}?',
  'city.greet.night.0': 'Es ist zu spät, um draußen zu sein. {name}.',
  'city.greet.night.1': 'Pass auf die Dunkelheit auf. {name}.',
  'city.greet.night.2': 'Noch immer. {name}?',
  'city.greet.morning.0.anon': 'Morgen, mein Freund!',
  'city.greet.morning.1.anon': 'Guten Morgen zu dir.',
  'city.greet.morning.2.anon': 'Bist du früh aufgestanden, mein Freund?',
  'city.greet.afternoon.0.anon': 'Guten Nachmittag, mein Freund.',
  'city.greet.afternoon.1.anon': 'Ich wünsche Ihnen einen guten Tag.',
  'city.greet.afternoon.2.anon': 'Gut, dass wir uns wieder getroffen haben.',
  'city.greet.evening.0.anon': 'Heute Abend, mein Freund.',
  'city.greet.evening.1.anon': 'Guten Abend!',
  'city.greet.evening.2.anon': 'Nicht zu Hause, Freund?',
  'city.greet.night.0.anon': 'Es ist zu spät, um draußen zu sein, mein Freund.',
  'city.greet.night.1.anon': 'Pass auf die Dunkelheit auf.',
  'city.greet.night.2.anon': 'Bist du noch da, mein Freund?',
  'city.market.title': 'Marktplatte',
  'city.market.shut': 'Es gibt jetzt nichts.',
  'city.market.later': 'Später heute:',
  'city.market.am': '{n} am Morgen',
  'city.market.pm': '{n} am Nachmittag',
  'city.market.eve': '{n} am Abend',
  'city.garden.title': 'Gartenplätze',
  'city.garden.tend': 'Die Handlung zu behalten.',
  'city.garden.tended': 'Sie ziehen ein paar Unkraut und gießen das Grundstück.',
  'city.garden.already': 'Du hast heute schon die Sache bearbeitet.',
  'city.garden.tendedNote': 'heute gepflegt',
  'city.garden.arrive': 'Die {crop} Hier sind die {stage}.',
  'city.garden.crop.herbs': 'Pflanzen',
  'city.garden.crop.apples': 'Apfelbäume',
  'city.garden.crop.kitchen': 'Küchengrün',
  'city.garden.crop.cabbages': 'Kohlen und Bohnen',
  'city.garden.crop.wheat': 'Weizenfelder',
  'city.garden.stage.bare': 'Nackt für den Winter',
  'city.garden.stage.sown': 'frisch gesät',
  'city.garden.stage.sprouting': 'Frühling',
  'city.garden.stage.growing': 'gut wachsen',
  'city.garden.stage.flowering': 'in Blumen',
  'city.garden.stage.ripe': 'reif und bereit',
  'city.garden.stage.harvested': 'für das Jahr geerntet',
  'city.fish.title': 'Fischerei',
  'city.fish.cast': 'Schieben Sie eine Linie',
  'city.fish.go': 'Geht!',
  'city.fish.here': 'Ein guter Fischerplatz.',
  'city.fish.casting': 'Sie stellen eine Zeile und warten.',
  'city.fish.caught': 'Irgendwas beißt. {fish}.',
  'city.fish.got.boot': 'Man rollt einen alten Schuh und wirft ihn zurück.',
  'city.fish.got.weed': 'Dieses Mal nur Flussweide.',
  'city.fish.got.nothing': 'Nichts beißt, das Wasser behält seine Geheimnisse.',
  'city.fish.casts': '{n} Werft so weit',
  'city.fish.none': 'Fische beißen am besten bei Morgendämmerung und Sonnenuntergang, und mehr im Frühjahr und Herbst.',
  'city.fish.spot.bank': 'Flussbank',
  'city.fish.spot.jetty': 'Jetty',
  'city.fish.spot.bridge': 'Mühlbrücke',
  'city.fish.name.perch': 'ein Stück',
  'city.fish.name.roach': 'ein Kakerlaken',
  'city.fish.name.trout': 'eine Forelle',
  'city.fish.name.eel': 'ein Egel',
  'city.fish.name.pike': 'ein Pike',
  'city.fish.name.carp': 'eine Karpe',
  'city.fish.name.minnow': 'ein Minnow',
  'city.fish.name.crayfish': 'ein Krebs',
  'city.fish.name.boot': 'ein alter Schuh',
  'city.fish.name.weed': 'Flussweide',
  'city.fish.name.nothing': 'Nichts .',
  'city.lost.title': 'Verloren und gefunden',
  'city.lost.none': 'Die Leute lassen Dinge auf den Märkten, auf dem Platz und an anderen geschäftigen Orten ab, wenn man dort steht, wo etwas liegt, holt es hier ab.',
  'city.lost.whose': 'gehört zu {name}',
  'city.lost.find': 'Finden Sie {name}',
  'city.lost.spot': 'Hier liegt etwas auf dem Boden: {thing}',
  'city.lost.pick': 'Nehmen Sie auf . {thing}',
  'city.lost.picked': 'Du nimmst auf . {thing}. Es sieht so aus , als gehörte es zu {name}.',
  'city.lost.give': 'Geben Sie {thing} Zurück zu {name}',
  'city.lost.thanks': '{name} ist froh zu haben {thing} Ich bin zurück.',
  'city.lost.thing.glove': 'Eine verlorene Handschuhe.',
  'city.lost.thing.keys': 'ein Schlüsselring',
  'city.lost.thing.locket': 'Eine kleine Medaille .',
  'city.lost.thing.toy': 'ein Holzspielzeug',
  'city.lost.thing.scarf': 'ein Wollschal',
  'city.lost.thing.purse': 'eine leere Tasche',
  'city.lost.thing.spectacles': 'ein Paar Brille',
  'city.lost.thing.letter': 'ein gefalteter Brief',
  'city.lost.thing.ribbon': 'ein Haarband',
  'city.lost.thing.pipe': 'ein Tonrohr',
  'city.records.title': 'Städtische Aufzeichnungen',
  'city.records.peak': 'Am beschäftigtesten heute bei {time}, mit {n} Die Leute aus der Stadt.',
  'city.records.now': 'In dieser Stunde: {out} Aus. {home} Zuhause.',
  'city.records.busiest': 'Das geschäftigste Viertel: {district}.',
  'city.records.outTitle': 'Stadtbewohner nach Stunde.',
  'city.records.seenTitle': 'Menschen, die du um dich herum gesehen hast, nach Stunde',
  'city.a11y.title': 'Zugänglichkeit',
  'city.a11y.text': 'Textgröße',
  'city.a11y.size1': 'Normal',
  'city.a11y.size125': 'Große',
  'city.a11y.size15': 'Größte',
  'city.a11y.stillOff': 'Verringerung der Bewegung',
  'city.a11y.stillOn': 'Verringerung der Motion',
  'city.a11y.contrastOff': 'Hoher Kontrast',
  'city.a11y.contrastOn': 'Hohe Kontraste zu',
  'city.tour.welcome.title': 'Willkommen bei {city}',
  'city.tour.welcome.body': 'Diese Stadt lebt auf ihrer eigenen Uhr. Die Leute wachen, arbeiten, essen und schlafen, ob man zusieht oder nicht. Hier ist ein kurzer Blick um.',
  'city.tour.walk.title': 'Geht zu Fuß',
  'city.tour.walk.body': 'Ihr Roboter findet seinen eigenen Weg um die Wände und durch Türen.',
  'city.tour.talk.title': 'Ich rede .',
  'city.tour.talk.body': 'Tippen Sie auf eine Person, um ihren Namen zu sehen, und gehen Sie zu ihr vorbei.',
  'city.tour.menu.title': 'Ich schaue näher .',
  'city.tour.menu.body': 'Auf einem Computer klicken Sie mit der rechten Klick auf etwas, um zu sehen, was Sie dort tun können, wie zum Beispiel ein Schild lesen, sich setzen oder ein Zimmer einnehmen.',
  'city.tour.map.title': 'Die Mindestkarte',
  'city.tour.map.body': 'Die kleine Karte in der Ecke zeigt Straßen, Bezirke und Menschen in Ihrer Nähe.',
  'city.tour.panel.title': 'Ihr Panel .',
  'city.tour.panel.body': 'Das Nebenpaneel zeigt die Personen in der Nähe, die Orte, die Sie entdeckt haben, Ihre Quests, Ihr Tagebuch und vieles mehr.',
  'city.tour.keys.title': 'Bewegungen',
  'city.tour.keys.body': 'Auf der Tastatur wird jede Bewegung des Roboters angezeigt.',
  'city.tour.done.title': 'Das ist alles.',
  'city.tour.done.body': 'Genießen Sie {city}. Sie können diese Tour noch einmal vom Seitenpaneel machen.',
  'city.tour.step': '{n} von {total}',
  'city.tour.next': 'Nächstes .',
  'city.tour.back': 'Zurück !',
  'city.tour.skip': 'Überspringen Sie die Tour.',
  'city.tour.finish': 'Beginnen Sie mit der Erforschung.',
  'city.tour.again': 'Machen Sie die Stadttour noch einmal.',
  'city.found.title': 'Entdeckte Orte',
  'city.found.count': '{n} von {total}',
  'city.found.none': 'Gehen Sie zu einem Ort, um es hier hinzuzufügen.',
  'city.found.new': 'Entdeckt {place}',
  'city.board.open': 'Lesen Sie das öffentliche Notizenbrett',
  'city.board.hint': 'Hier sind Notizen, die andere Reisende hinterlassen haben, ein kurzes von Ihnen, keine Links, und bis zu drei von Ihnen bleiben gleichzeitig.',
  'city.board.placeholder': 'Schreiben Sie eine kurze Notiz, damit andere sie finden',
  'city.board.pin': 'Schließe die Notiz ein.',
  'city.board.loading': 'Ich las die Tafel.',
  'city.board.by': '{name}, {when}',
  'city.board.remove': 'Schreib dir den Brief auf .',
  'city.board.err.signin': 'Melden Sie sich an, um eine Notiz festzuhalten.',
  'city.board.err.soon': 'Warten Sie ein wenig, bevor Sie noch eine Notiz anlegen.',
  'city.board.err.bad': 'Die Notizen müssen bis zu 200 Zeichen langen Text sein, ohne Links.',
  'city.board.err.down': 'Der Vorstand ist jetzt nicht zu erreichen.',
  'city.room.rent': 'Nehmen Sie sich ein Zimmer {place}',
  'city.room.move': 'Bewegen Sie Ihr Zimmer zu {place}',
  'city.room.yours': 'Ihr Zimmer in {place}',
  'city.room.decorate': 'Setzen Sie hier etwas.',
  'city.room.remove': 'Nehmen Sie die {thing}',
  'city.room.leave': 'Geben Sie Ihr Zimmer auf .',
  'city.room.full': 'Ihr Zimmer hat keinen Platz für mehr.',
  'city.room.pickTitle': 'Möbeln Sie Ihr Zimmer.',
  'city.room.pickHint': 'Wählen Sie etwas, das Sie an diesem Ort einstellen. Es bleibt in Ihrem Zimmer auf diesem Gerät.',
  'city.room.kind.rug': 'Ein Gewebtem Teppich',
  'city.room.kind.candle': 'Eine Kerze .',
  'city.room.kind.flowers': 'Ein Topf Blumen',
  'city.room.kind.painting': 'Ein Gemälde',
  'city.room.kind.plant': 'Eine Pflanze in Topfen',
  'city.room.kind.chest': 'Eine kleine Brust .',
  'city.room.kind.lantern': 'Eine Laterne',
  'city.room.kind.books': 'Ein paar Bücher .',
  'city.busk.lute': '{name} schlägt eine helle Melodie in der Nähe',
  'city.busk.fiddle': '{name} Siehe eine lebhafte Rolle in der Nähe',
  'city.busk.pipe': '{name} spielt eine langsame Luft in der Nähe',
  'city.busk.drum': '{name} Schlägt einen Tanz in der Nähe aus',
  'city.tail.label': 'Nachfolgend {name}',
  'city.tail.title': 'Schwanz {name} durch den Tag',
  'city.tail.now': 'Und jetzt: {activity} in der {place}',
  'city.tail.unknown': 'Ihre Pläne sind bisher unbekannt.',
  'city.tail.next': 'Als Nächstes: {place} in der {time}, in {h} h {m} Min.',
  'city.tail.trail': 'Durchschnitten: {places}',
  'city.tail.stop': 'Hören Sie auf zu folgen.',
  'city.pins.add': 'Hinzufügen',
  'city.pins.tapMap': 'Tippen Sie auf die Karte, um Ihren Pin zu platzieren',
  'city.pins.walk': 'Gehen Sie zu diesem Stift .',
  'city.pins.note': 'Schliessen Sie auf {x}, {y}. Fügen Sie eine Note hinzu',
  'city.pins.noteLabel': 'Anschrift',
  'city.pins.remove': 'Entfernen Sie diesen Stift .',
  'city.pins.here': 'Flicken Sie diesen Punkt auf der Karte',
  'city.compass.north': 'Norden',
  'city.compass.at': 'x {x}, y {y}, Boden {floor}',
  'city.door.prop': 'Stell die Tür offen.',
  'city.door.close': 'Lasst die Tür schließen.',
  'city.door.unlock': 'Öffnen Sie die Tür.',
  'city.door.lock': 'Schließen Sie die Tür.',
  'city.books.browse': 'Durchsuchen Sie das Regal',
  'city.books.shelf': 'Schelf am {place}',
  'city.books.book': 'Buch',
  'city.books.scroll': 'Rollen',
  'city.books.prev': 'Vorherige',
  'city.books.back': 'Zurück zum Regal .',
  'city.books.next': 'Nächstes .',
  'city.books.page': 'Seite {n} von {of}',
  'city.sign.readSign': 'Lesen Sie das Schild .',
  'city.sign.readPlaque': 'Lesen Sie die Plaque',
  'city.sign.sign': 'Ein gemaltes Schild',
  'city.sign.plaque': 'Eine Tafel an der Tür',
  'city.district.entering': 'Jetzt kommt ich rein .',
  'city.district.riverside': 'Die Flussseite und die niedrigen Märkte',
  'city.district.sunwalk': 'Sonnenwandel',
  'city.district.lanes': 'Die Lanes',
  'city.district.monastery': 'Das Kloster',
  'city.district.castle': 'Das Schloss',
  'city.district.drains': 'Die alten Abwässer',
  'city.district.farmlands': 'Die Landwirtschaftsgebiete',
  'city.photo.enter': 'Bildmodus',
  'city.photo.hint': 'Ziehen Sie sich um, machen Sie einen Screenshot, um ihn zu behalten.',
  'city.photo.leave': 'Verlassen Sie den Foto-Modus',
  'city.building.who': 'Wer lebt und arbeitet {place}',
  'city.building.live': 'Sie wohnt hier.',
  'city.building.work': 'Wir arbeiten hier.',
  'city.building.now': 'Jetzt drinnen .',
  'city.building.rooms': 'Wird eingesetzt. {list}.',
  'city.inspect.about': 'Über {name}',
  'city.inspect.close': 'Schließen',
  'city.inspect.unknown': 'Niemand kann dir viel darüber erzählen. {name}.',
  'city.inspect.home': 'Zuhause',
  'city.inspect.work': 'Arbeit',
  'city.inspect.none': 'Keine bekannt .',
  'city.inspect.today': 'Heute',
  'city.inspect.row': '{what}, {place}',
  'city.inspect.follow': 'Folgen Sie mir . {name} durch den Tag',
  'city.overlay.label': 'Kartenüberlagerungen',
  'city.overlay.crowd': 'Menschenmengen',
  'city.overlay.light': 'Licht',
  'city.overlay.noise': 'Lärm',
  'city.bar.pop': '{n} Ich wohne hier.',
  'city.bar.out': '{n} Jetzt raus .',
  'city.bar.season.spring': 'Frühling',
  'city.bar.season.summer': 'Sommer',
  'city.bar.season.autumn': 'Herbst',
  'city.bar.season.winter': 'Der Winter',
  'city.notebook.title': 'Ich habe gehört und gelernt.',
  'city.notebook.all': 'Alle .',
  'city.notebook.heard': 'Ich habe gehört .',
  'city.notebook.learned': 'Erlernt',
  'city.notebook.search': 'Durchsuchen Sie Ihre Notizen .',
  'city.notebook.none': 'Hör auf auf der Straße und sprich mit den Leuten.',
  'city.ask.title': 'Fragen Sie sich um .',
  'city.ask.pick': '- Wem suchen Sie?',
  'city.ask.ask': 'Fragen Sie .',
  'city.ask.passerby': 'Ein Passanten .',
  'city.ask.nobody': 'Es gibt niemanden in der Nähe, um zu fragen.',
  'city.ask.unseen': '{asker} hat nicht gesehen {who} Über den heutigen Tag.',
  'city.ask.here': '{asker} sagt: {who} ist in der Nähe {place}.',
  'city.ask.go': 'Geht zu {who}',
  'city.weather.clear': 'Klarer Himmel',
  'city.weather.cloudy.light': 'Ein paar Wolken .',
  'city.weather.cloudy.heavy': 'Grau und überschattet',
  'city.weather.rain.light': 'Leichter Regen',
  'city.weather.rain.heavy': 'Es regnet heftig.',
  'city.weather.fog.light': 'Morgennebel',
  'city.weather.fog.heavy': 'Dichter Nebel',
  'city.weather.snow.light': 'Leichter Schnee',
  'city.weather.snow.heavy': 'Schweres Schnee',
  'city.lamplighter.name': 'Leuchter',
  'city.lamplighter.lighting': 'die Straßenleuchten anzünden',
  'city.lamplighter.dousing': 'die Straßenleuchten auslöschen',
  'city.hourglass.title': 'Sanduhr',
  'city.hourglass.stop': 'Haltet den Tag auf.',
  'city.hourglass.paused': 'Der Tag steht still.',
  'city.hourglass.resume': 'Geht weiter.',
  'city.seat.bench': 'Bank',
  'city.seat.chair': 'Stuhl',
  'city.seat.sit': 'Setzen Sie sich auf die {what}',
  'city.inside.crate': 'Schachtel',
  'city.inside.barrel': 'Barrel',
  'city.inside.title': 'Im Inneren der {what}',
  'city.inside.look': 'Schauen Sie in die {what}',
  'city.inside.holds': 'Das ist es. {fill}: {list}.',
  'city.factions.title': 'Stehend in der Stadt',
  'city.factions.wary': 'Warn dich .',
  'city.factions.unknown': 'Unbekannt',
  'city.factions.noticed': 'Aufmerksam gemacht',
  'city.factions.trusted': 'Zuverlässig',
  'city.factions.honored': 'Ehrwürdig',
  'city.factions.done': 'Erledigt: {n}.',
  'city.mail.title': 'Briefe',
  'city.mail.none': 'Noch keine Briefe.',
  'city.mail.from': 'Von {name}',
  'city.mail.waiting': 'Ich warte auf eine Antwort von {names}.',
  'city.mail.nobody': 'Helfen Sie jemandem mit einem Auftrag und Sie können ihm schreiben.',
  'city.mail.write': 'Schreiben Sie einen Brief .',
  'city.mail.to': 'Wem?',
  'city.mail.subject': 'Betrifft',
  'city.mail.body': 'Ihr Brief .',
  'city.mail.send': 'Schicken Sie es .',
  'city.mail.untitled': 'Ein paar Zeilen .',
  'city.moth.title': 'Der Schublade der Motte',
  'city.moth.trade': 'Tun Sie mir einen Gefallen.',
  'city.moth.yours': 'Jetzt deine.',
  'city.spy.title': 'Ruhige Arbeit',
  'city.cut.skip': 'Überspringen',
  'city.party.title': 'Spielen Sie zusammen.',
  'city.party.blurb': 'Beginnen Sie eine Party und teilen Sie ihren Code mit Freunden. Alle sehen sich überall in der Stadt, nicht nur in den gemeinsamen Räumen.',
  'city.party.start': 'Beginnen Sie eine Party.',
  'city.party.codeLabel': 'Party-Code',
  'city.party.join': 'Wir werden uns anschließen .',
  'city.party.bad': 'Ein Partykode besteht aus vier bis acht Buchstaben oder Zahlen.',
  'city.party.code': 'Ihr Partykode ist: {code}. Teilen Sie es mit Freunden, damit sie sich anschließen können.',
  'city.party.alone': 'Niemand von deiner Partei ist gerade in der Stadt.',
  'city.party.here': 'direkt neben dir.',
  'city.party.away': '{n} Schritte {dir}',
  'city.party.floor': '(Boden {n})',
  'city.party.go': 'Gehen Sie .',
  'city.party.leave': 'Verlassen Sie die Party.',
  'city.party.dir.east': 'Osten',
  'city.party.dir.south-east': 'Südosten',
  'city.party.dir.south': 'Süd',
  'city.party.dir.south-west': 'Südwesten',
  'city.party.dir.west': 'Westen',
  'city.party.dir.north-west': 'Nordwest',
  'city.party.dir.north': 'Nord',
  'city.party.dir.north-east': 'Nordosten',
  'city.print.title': 'Drucken Sie ein Gebäude',
  'city.print.here': '{name}: {w} durch {d} Zellen, Böden: {n}. Speichern Sie es als STL für einen 3D-Drucker.',
  'city.print.none': 'Stehen Sie in oder neben einem Gebäude, um es als STL für einen 3D-Drucker zu speichern.',
  'city.print.model': 'Speichern von STL, Modellskala (5 mm pro Zelle)',
  'city.print.tabletop': 'Speichern Sie STL, Tischskala (1 Zoll pro Zelle)',
  'city.print.note': 'Wände, Böden, Türen, Treppen und Fenster, wie die Stadt sie zeichnet, auf einer Basisplatte, so dass es in einem Stück druckt.',
  'city.print.models': 'Figuren und Requisiten, zum Drucken bereit:',
  'city.print.busy': 'Ich bereite...',
  'city.print.model.figure': 'Walker-Figur, 28 mm auf einer Basis von 25 mm',
  'city.print.model.fountain': 'Brunnen, 3 Zoll breit',
  'city.print.model.castle-wall': 'Teil der Burgmauern, 3 Zoll lang',
  'city.editor.stl': 'Speichern Sie STL',
  'city.editor.title': 'Stadtkarten-Editor',
  'city.editor.blurb': 'Malen Sie eine Stadtkarte Boden für Boden: Wände, Straßen, Türen, Wasser, Leiter und benannte Orte. Der folgende Check liest sie mit dem gleichen Kartenleser, den die lebende Stadt verwendet. Ihr Entwurf speichert in diesem Browser; exportieren Sie es als Datei, die Sie behalten oder teilen können.',
  'city.editor.name': 'Name der Karte',
  'city.editor.tools': 'Werkzeuge',
  'city.editor.tool.pen': 'Schreibfläche',
  'city.editor.tool.rect': 'Block',
  'city.editor.tool.room': 'Zimmer',
  'city.editor.tool.fill': 'Füllung',
  'city.editor.tool.spawn': 'Ausgangspunkt',
  'city.editor.tiles': 'Boden',
  'city.editor.letter': 'Schreiben',
  'city.editor.placeName': 'Ortsname',
  'city.editor.addPlace': 'Fügen Sie Platz hinzu',
  'city.editor.placeBad': 'Ein Ort braucht einen Buchstaben und einen Namen.',
  'city.editor.floors': 'Schritte',
  'city.editor.addFloor': 'Fläche hinzufügen',
  'city.editor.map': 'Karte',
  'city.editor.width': 'Breite',
  'city.editor.height': 'Höhen',
  'city.editor.new': 'Neue Karte',
  'city.editor.undo': 'Vernichtet',
  'city.editor.export': 'Export',
  'city.editor.import': 'Importe',
  'city.editor.loaded': 'Karte geladen.',
  'city.editor.zoom': 'Vergrößern',
  'city.editor.check': 'Überprüfen',
  'city.editor.ok': 'Das ist klar. {walk} offene Zellen, {reach} erreichbar vom Startpunkt.',
  'city.editor.placeSpots': '{name}: {n} Zellen',
  'city.editor.canvas': 'Kartenkanvas',
  'city.spy.take': 'Nehmen Sie es.',
  'city.spy.again': 'Versuchen Sie es nochmal.',
  'city.spy.drop': 'Lassen Sie es gehen.',
  'city.spy.progress': '{n} Das ist ein Prozent.',
  'city.spy.carrying': 'Sie haben den Brief.',
  'city.spy.underway': 'Sie sind unterwegs.',
  'city.spy.done': 'Das ist alles.',
  'city.spy.failed': 'Letztes Mal ging es schief.',
  'city.menu.look': 'Sieh dir das an. {thing}',
  'city.menu.street': 'Die Straße',
  'city.menu.wall': 'Eine Wand',
  'city.continue': 'Weiter',
  'city.goodbye': '- Auf Wiedersehen.',
  'city.board.title': 'Belohnungsschild',
  'city.arrive.rooftops': 'Sie ziehen sich auf die Dächer, die Gassen öffnen sich unter Ihnen, und die Bretter zwischen den Häusern kratzen unter den Füßen.',
  'city.arrive.museumRoof': 'Du ziehst die alte Eide auf das Museumdach und der Sunwalk Plaza breitet sich wie ein Spielbrett aus.',
  'city.crier.title': 'Das Blatt des Schreiers',
  'city.crier.today': 'Heute ist {name}.',
  'city.crier.tomorrow': '{name} Das ist morgen.',
  'city.crier.coming': '{name} in {n} Tage lang.',
  'city.crier.stalls': 'Auf den Ständen am ersten Morgen:',
  'city.crier.notices': '{n} Aufmerksamkeiten auf dem Kopfgeldbrett.',
  'city.crier.talk': 'Von der Stadt:',
  'city.crier.now': 'Was gerade in der Stadt passiert:',
  'city.board.empty': 'Heute ist nichts festgehalten.',
  'city.board.posted': 'Veröffentlicht von {name}.',
  'city.board.postedAt': 'Veröffentlicht von {name}, jetzt bei {place}.',
  'city.board.days': '{n} Tage übrig.',
  'city.board.find': 'Finden Sie sie .',
  'city.topics.ask': '{word}?',
  'city.talkWith': 'Ich rede mit ... {name}',
  'city.journal': 'Zeitschrift',
  'city.journalNone': 'Noch nichts geschrieben.',
  'city.quests': 'Flächen und Flächen',
  'city.questNone': 'Noch keine, reden Sie mit den Leuten.',
  'city.rest': 'Ruhe {n} Minuten',
  'city.saves.title': 'Speicherte Spiele',
  'city.saves.slot': 'Schlitz {n}: {day} {time}, {place}',
  'city.saves.empty': 'Schloss {n}: leer',
  'city.saves.save': 'Hier sparen.',
  'city.saves.load': 'Lasten',
  'city.saves.sure': 'Tippen Sie noch einmal, um zu bestätigen',
  'city.saves.hint': 'Eine Rettung hält die ganze Stadt so, wie sie steht: Wo du bist, die Stunde, die Leute, Quests und Brüste.',
  'city.restHint': 'Du kannst nur so viel in einer Stunde ruhen.',
  'city.bed.ask': 'Schlafen Sie ein . {bed}?',
  'city.bed.night': 'Acht Stunden vergehen, während du schläfst, und du ruhst nach den Regeln deines Spielsystems.',
  'city.bed.sleep': 'Schlafen',
  'city.bed.notNow': 'Nicht jetzt.',
  'city.bed.tired': 'Du bist noch nicht müde. {n} Stunden lang.',
  'city.bed.asleep': 'Die Nacht vergeht.',
  'city.bed.offer': 'Schlafen Sie hier.',
  'city.vitals': 'Gesundheit',
  'city.bed.woke': 'Du schläfst da drin. {bed} und aufwachen {time}. {change}',
  'city.bed.change': '{label}: {before} zu {after}.',
  'city.bed.noRest': 'Die {system} Regeln geben keine Erholung für Ruhe, also wird nichts repariert.',
  'city.bed.beds': 'Betten',
  'city.bed.demoRules': 'Regeln für die Bettprüfung: {system}. Fügen Sie "Regeln" hinzu, um eine andere zu versuchen.',
  'city.messages': 'Anmerkungen',
  'city.rules': 'Spielsystem',
  'city.rulesNarrative': 'Keine Regeln: die Stadt als Geschichte, wählen Sie ein System, um alle in ihren Zahlen zu sehen.',
  'city.statsFor': 'Zahlen für',
  'city.sparTitle': 'Übungsspiel',
  'city.sparA': 'Erster Kämpfer',
  'city.sparB': 'Zweiter Kämpfer',
  'city.sparVs': 'gegen',
  'city.sparRun': 'Kämpfen',
  'city.sparNote': 'Eine Demonstration in diesem System, niemand in der Stadt ist verletzt.',
  'city.sparRound': 'Runde {n}.',
  'city.zoomIn': 'Vergrößern',
  'city.pivot.left': 'Ansicht nach links drehen',
  'city.pivot.right': 'Ansicht nach rechts drehen',
  'city.pivot.north': 'Nach Norden ausrichten',
  'city.zoomOut': 'Vergrößern',
  'city.centre': 'Zentrum auf mich.',
  'city.followOn': 'Folgen Sie weiter .',
  'city.followOff': 'Folgen Sie mir .',
  'city.followOnHint': 'Die Kamera folgt Ihnen.',
  'city.followOffHint': 'Schlag mich an, um wieder zu dir zu springen.',
  'city.minimapShow': 'Karte zeigen',
  'city.minimapHide': 'Karte ausblenden',
  'city.minimapOpen': 'Klopfen Sie, um es größer zu öffnen.',
  'city.minimapWalk': 'Steck auf einen Ort, um dorthin zu gehen.',
  'city.minimapSmall': 'Karte verkleinern',
  'city.minimapHint': 'Klopfen , um dort zu gehen .',
  'city.chatter.morning.1.a': 'Frisches Brot bei den Ecköfen, wenn Sie sich beeilen.',
  'city.chatter.morning.1.b': 'Ich habe es zwei Straßen vor mir geräuchert.',
  'city.chatter.morning.2.a': 'Du bist früh aufgestanden.',
  'city.chatter.morning.2.b': 'Die Glocken weckten mich auf.',
  'city.chatter.morning.3.a': 'Sind die Kutschen durch das Tor hereingekommen?',
  'city.chatter.morning.3.b': 'Drei von ihnen, und einer verlor ein Rad auf der Brücke.',
  'city.chatter.morning.4.a': 'Heute Morgen ist es kalt.',
  'city.chatter.morning.4.b': 'Der Flussnebel wird um Mittag abbrennen.',
  'city.chatter.morning.5.a': 'Wo willst du hin?',
  'city.chatter.morning.5.b': 'Der Markt, bevor die guten Äpfel verschwunden sind.',
  'city.chatter.afternoon.1.a': 'Ein beschäftigter Tag in den Ständen.',
  'city.chatter.afternoon.1.b': 'Ich bin zu beschäftigt, meine Füße haben aufgegeben.',
  'city.chatter.afternoon.2.a': 'Hast du heute den Tanner gesehen?',
  'city.chatter.afternoon.2.b': 'Er ging vor einer Stunde ins Wasser.',
  'city.chatter.afternoon.3.a': 'Die Sonne ist heute nett.',
  'city.chatter.afternoon.3.b': 'Es regnet, ich spüre es im Knie.',
  'city.chatter.afternoon.4.a': 'Was wollte der Fischhändler für die Ängeln?',
  'city.chatter.afternoon.4.b': 'Ich habe stattdessen Rüben gekauft.',
  'city.chatter.afternoon.5.a': 'Ist das ein neuer Wagen?',
  'city.chatter.afternoon.5.b': 'Die Räder schwirren immer noch wie die alten.',
  'city.chatter.evening.1.a': 'Gehst du schon nach Hause?',
  'city.chatter.evening.1.b': 'Das Abendessen kocht sich nicht selbst.',
  'city.chatter.evening.2.a': 'Die Lampen kommen an.',
  'city.chatter.evening.2.b': 'Dann bin ich wieder zu spät.',
  'city.chatter.evening.3.a': 'Bist du heute Abend in der Taverne?',
  'city.chatter.evening.3.b': 'Wenn meine Frau es mir erlaubt, ja.',
  'city.chatter.evening.4.a': 'Ein langer Tag.',
  'city.chatter.evening.4.b': 'Das sind sie alle, zu dieser Jahreszeit.',
  'city.chatter.evening.5.a': 'Schließen Sie heute Abend Ihre Fenster.',
  'city.chatter.evening.5.b': 'Das mache ich immer. Der Wind zittert sie sowieso.',
  'city.chatter.night.1.a': 'Wer geht dahin?',
  'city.chatter.night.1.b': 'Ich allein, leg die Laterne runter.',
  'city.chatter.night.2.a': 'Du solltest schlafen.',
  'city.chatter.night.2.b': 'Das solltest du auch, mein Freund.',
  'city.chatter.night.3.a': 'Hast du etwas am Wasser gehört?',
  'city.chatter.night.3.b': 'Katzen, es sind immer Katzen.',
  'city.chatter.night.4.a': 'Eine ruhige Nacht.',
  'city.chatter.night.4.b': 'Lassen Sie es so bleiben.',
  'city.chatter.any.1.a': 'Hast du die Nachrichten gehört?',
  'city.chatter.any.1.b': 'Es gibt immer Neuigkeiten.',
  'city.chatter.any.2.a': 'Ich wünsche Ihnen einen guten Tag.',
  'city.chatter.any.2.b': 'Und für dich.',
  'city.chatter.any.3.a': 'Mein Cousin schwört, dass der alte Turm gefolgt ist.',
  'city.chatter.any.3.b': 'Dein Cousin schwört viele Dinge.',
  'city.chatter.any.4.a': 'Die Preise steigen weiter.',
  'city.chatter.any.4.b': 'Und mein Lohn bleibt stehen.',
  'city.chatter.any.5.a': 'Pass auf den Pudel auf.',
  'city.chatter.any.5.b': 'Zu spät, danke trotzdem.',
  'city.chatter.any.6.a': 'Ist das der Fremde, den alle erwähnen?',
  'city.chatter.any.6.b': 'Stare nicht so, das ist unhöflich.',
  'city.chatter.any.7.a': 'Wie geht es deiner Mutter?',
  'city.chatter.any.7.b': '- Sie hat mich wieder bestritten.',
  'city.chatter.any.8.a': 'Ich schulde dir einen Drink, oder?',
  'city.chatter.any.8.b': 'Zwei, nach meiner Abzählung.',
  'city.inventory.title': 'Ihr Paket .',
  'city.inventory.subtitle': 'Montkelianische Tasche',
  'city.inventory.close': 'Schließen Sie Ihr Gepäck.',
  'city.inventory.tabs': 'Verpackungsabschnitte',
  'city.inventory.tab.inventory': 'Inventar',
  'city.inventory.tab.journal': 'Zeitschrift',
  'city.inventory.tab.map': 'Karte',
  'city.inventory.empty': 'Alles, was Sie auf Reisen finden, wird in diese Taschen aufbewahrt.',
  'city.inventory.slots': 'Taschen',
  'city.inventory.slotEmpty': 'Tasche {n}, leer',
  'city.inventory.slot.headgear': 'Kopfbedeckung',
  'city.inventory.slot.helmet': 'Helm',
  'city.inventory.slot.hat': 'Hüte',
  'city.inventory.slot.hood': 'Hut',
  'city.inventory.slot.amulet': 'Amulett',
  'city.inventory.slot.cloak': 'Gewand',
  'city.inventory.slot.tabard': 'Tabard',
  'city.inventory.slot.pelt': 'Fell',
  'city.inventory.slot.armor': 'Rüstung',
  'city.inventory.slot.plate': 'Platte',
  'city.inventory.slot.robe': 'Kleider',
  'city.inventory.slot.jerkin': 'Ich bin ein Arschloch.',
  'city.inventory.slot.hide': 'Verbergen Sie sich',
  'city.inventory.slot.girdle': 'Girdle',
  'city.inventory.slot.belt': 'Gürtel',
  'city.inventory.slot.bracers': 'Triebschläger',
  'city.inventory.slot.gloves': 'Handschuhe',
  'city.inventory.slot.mainHand': 'Haupthand',
  'city.inventory.slot.offHand': 'Nicht mehr in der Hand',
  'city.inventory.slot.twoHand': 'Beide Hände',
  'city.inventory.slot.sword': 'Schwert',
  'city.inventory.slot.shield': 'Schild',
  'city.inventory.slot.staff': 'Mitarbeiter',
  'city.inventory.slot.focus': 'Konzentrieren Sie sich',
  'city.inventory.slot.ring': 'Ringe',
  'city.inventory.slot.leggings': 'Leggings',
  'city.inventory.slot.greaves': 'Schlagzeilen',
  'city.inventory.slot.boots': 'Stiefel',
  'city.inventory.item.sword': 'Schwert',
  'city.inventory.item.shield': 'Schild',
  'city.inventory.item.knife': 'Messer',
  'city.inventory.item.axe': 'Achse',
  'city.inventory.item.tabard': 'Tabard',
  'city.inventory.item.cape': 'Kapsel',
  'city.inventory.item.ring': 'Ringe',
  'city.inventory.class.default': 'Reisende',
  'city.inventory.class.fighter': 'Kämpfer',
  'city.inventory.class.paladin': 'Paladin',
  'city.inventory.class.berserker': 'Berserker',
  'city.inventory.class.wizard': 'Zauberer',
  'city.inventory.class.rogue': 'Schwachkopf',
  'city.inventory.slotFree': 'Leere',
  'city.inventory.gear': 'Was du trägst',
  'city.inventory.view': 'Schauen Sie .',
  'city.inventory.viewGear': 'Gebrauch',
  'city.inventory.viewPockets': 'Taschen',
  'city.inventory.avatarHint': 'Wählen Sie einen anderen Avatar aus dem Menü unter Avatar.',
  'city.inventory.soon.journal': 'Ihr Tagebuch ist zurzeit leer, Quests und Notizen, die Sie sammeln, werden hier geschrieben.',
  'city.inventory.soon.map': 'Ihre gefaltete Karte wird hier aufbewahrt, gekennzeichnet mit den Orten, an denen Sie gewesen sind.',
  'city.inventory.hint': 'Tippen Sie sich an, um Ihre Tasche zu öffnen',
  'city.avatar': 'Avatar',
  'city.avatarLabel': 'Wählen Sie Ihren Avatar',
  'city.avatar.robot': 'Roboter',
  'city.avatar.nycanthea': 'Nycanthea',
  'city.avatar.paladin': 'Paladin',
  'city.avatarCloth': 'Gewebe',
  'city.avatarClothHint': 'Kapen und Tabarde schwenken, während Sie sich bewegen.',
  'city.soundOn': 'Schalten Sie den Ton ein .',
  'city.soundOff': 'Schalten Sie den Ton aus',
  'city.musicOn': 'Spielen Sie Musik.',
  'city.musicOff': 'Hör auf mit der Musik.',
  'city.walkSpeed': 'Geschwindigkeit',
  'city.walkSpeedLabel': 'Fahrgeschwindigkeit',
  'city.walkSpeedValue': '{n}x',
  'city.me': 'Ich habe es getan.',
  'city.quality': 'Qualität',
  'city.qualityAuto': 'Automatisierte{tier})',
  'city.tier.low': 'Niedrig',
  'city.tier.medium': 'Mittelwert',
  'city.tier.high': 'Höchste',
  'city.robot.keys': 'Roboterschlüssel',
  'city.robot.title': 'Roboterschlüssel',
  'city.robot.intro': 'Drücken Sie eine Taste oder tippen Sie hier, und Ihr Roboter macht es für alle in der Nähe zu sehen. Es ist nur für die Show und ändert nichts im Spiel.',
  'city.robot.close': 'Schließen',
  'city.robot.jumpNote': 'Drücken Sie noch einmal Space, während Sie in der Luft sind, um doppelt zu springen.',
  'city.robot.spellNote': 'Im Zaubermodus werden 1, 2 und 3 statt des Angriffs geworfen.',
  'city.robot.climbNote': 'Sie können die Treppe, die Ihnen am nächsten ist, erklimmen, oder Sie können auch auf eine Treppe gehen oder an die Treppe klopfen.',
  'city.robot.walkNote': 'W, A, S und D gehen nach Norden, Westen, Süden und Osten Schritt für Schritt.',
  'city.robot.walk.north': 'Geh nach Norden.',
  'city.robot.walk.west': 'Geh nach Westen.',
  'city.robot.walk.south': 'Gehen Sie nach Süden.',
  'city.robot.walk.east': 'Geh nach Osten.',
  'city.stairs.label': 'Geh die Treppe .',
  'city.stairs.up': 'Aufstehen',
  'city.stairs.down': '- Nieder .',
  'city.stairs.goUp': 'Geh auf die Etage .',
  'city.stairs.goDown': 'Geh runter .',
  'city.robot.toggleNote': 'Waffenmodus, Zaubermodus, Schleife, Tanz und Fall bleiben bis Sie wieder drücken.',
  'city.robot.typing': 'Die Schlüssel tun nichts, während Sie in eine Schachtel tippen.',
  'city.robot.inSpell': 'Spellmodus: {act}',
  'city.robot.otherwise': 'Ansonsten: {act}',
  'city.robot.pad': 'Aktionen',
  'city.robot.padShow': 'Anzeigen Sie die Aktionsplattform',
  'city.robot.padHide': 'Verbergen Sie die Aktionsplatte',
  'city.robot.padTouch': '(für Touchscreen)',
  'city.robot.noLadder': 'Keine Treppe oder Leiter in der Nähe',
  'city.robot.act.jump': 'Springen Sie.',
  'city.robot.act.double-jump': 'Doppelspringen',
  'city.robot.act.dodge': 'Ausweichen .',
  'city.robot.act.block': 'Blockieren oder verteidigen',
  'city.robot.act.parry': 'Parry',
  'city.robot.act.weapon-mode': 'Waffenmodus',
  'city.robot.act.spell-mode': 'Spellmodus',
  'city.robot.act.slash': 'Schnitt',
  'city.robot.act.thrust': 'Antrieb',
  'city.robot.act.flurry': 'Schütteln .',
  'city.robot.act.cast': 'Gemischte',
  'city.robot.act.cast-spell': 'Verzauberung',
  'city.robot.act.megacast': 'Megacast',
  'city.robot.act.duck': 'Duck .',
  'city.robot.act.sneak': 'Schwindel',
  'city.robot.act.sing': 'Singen Sie .',
  'city.robot.act.dance': 'Tanzen',
  'city.robot.act.barf': 'Schnurrbarkeit',
  'city.robot.act.fall': 'Fallen oder aufstehen',
  'city.robot.act.climb-up': 'Klettern Sie auf.',
  'city.robot.act.climb-down': 'Klettern Sie runter.',
  'city.robot.act.hurt': 'Nehmen Sie einen Schlag.',
  'city.robot.act.kneel': 'Knie und Stehen',
  'city.robot.act.bow': 'Beugung',
  'city.robot.act.cheer': 'Freut euch über den Sieg',
  'city.panelShow': 'Anzeige-Panel',
  'city.phone.menu': 'Speisekarte',
  'city.phone.close': 'Schließungsmenü',
  'city.phone.view': 'Karte',
  'city.phone.sound': 'Klang und Tempo',
  'city.phone.people': 'Finden Sie jemanden.',
  'city.phone.more': 'Alles andere .',
  'city.phone.hint': 'Schlagen Sie den Boden, um zu gehen, schlagen Sie eine Person, um zu sprechen.',
  'city.phone.gotIt': 'Ich hab\'s.',
  'city.panelHide': 'Versteckpaneel',
  'city.canvasLabel3d': 'Karte von {city} Ziehen Sie herum, um sich zu umsehen, knichen Sie oder scrollen Sie, um zu vergrößern, tippen Sie, umzugehen oder zu sprechen.',
  'city.dock.label': 'Menschen zu finden',
  'city.dock.go': 'Gehen Sie zu. {name}',
  'city.dock.walking': 'Ich gehe zu Fuß. {name}',
  'city.dock.toPlace': 'Ich gehe zu Fuß. {name} in der {place}',
  'city.dock.cancel': 'Schlag auf den Boden, um zu stoppen',
  'city.rigDebug.open': 'Debug, wie {name} sich bewegt',
  'city.rigDebug.title': 'Ausrüstungsschutz: {name}',
  'city.rigDebug.close': 'Schließen',
  'city.rigDebug.move': 'Bewegung',
  'city.rigDebug.facing': 'Angesichts',
  'city.rigDebug.allMoves': 'Alle Bewegungen',
  'city.rigDebug.allFacings': 'Alle Gesichter',
  'city.rigDebug.cycling': 'Fahrradfahren, {s} s jeder',
  'city.rigDebug.play': 'Spielen',
  'city.rigDebug.pause': 'Pause',
  'city.rigDebug.back': 'Ein Schritt zurück.',
  'city.rigDebug.forward': 'Ein Schritt nach vorne , ein Rahmen .',
  'city.rigDebug.speed': 'Geschwindigkeit',
  'city.rigDebug.hint': 'Pause, Schritt für Schritt, drücken Sie nach außen oder drücken Sie Escape, um zu schließen.',
  'city.rigDebug.anim.idle': 'Untätig',
  'city.rigDebug.anim.walk': 'Gehen Sie',
  'city.rigDebug.debug': 'Debug',
  'city.rigDebug.viewLabel': 'Ansicht',
  'city.rigDebug.view.2d': '2D',
  'city.rigDebug.view.iso': 'Isometrische',
  'city.rigDebug.view.3d': '3D',
  'city.rigDebug.facingIs': 'aufgerichtet {dir}',
  'city.rigDebug.cell': 'Zeile {row}, Rahmen {col}',
  'city.rigDebug.loading': 'Belastung',
  'city.rigDebug.clip': 'Ein Klip',
  'city.rigDebug.allClips': 'Alle Clips',
  'city.rigDebug.noClips': 'Keine Clips',
  'city.rigDebug.layers': 'Schauen Sie .',
  'city.rigDebug.show.model': 'Modell',
  'city.rigDebug.show.bones': 'Knochen',
  'city.rigDebug.show.pieces': 'Stücke',
  'city.rigDebug.boneCount': '{n} Knochen',
  'city.rigDebug.no3d': 'Die 3D-Ansicht konnte auf diesem Bildschirm nicht starten.',
  'city.rigDebug.hint3d': 'Ziehen Sie, um die Kamera zu drehen, pausieren Sie, um Schritt für Schritt zu machen, tippen Sie auf die Tür oder drücken Sie Escape, um zu schließen.',
  'city.rigDebug.standIn': '{name} ist auf der {body} Ihr Körper ist hier, bis ihr eigener fertig ist.',
  'city.rigDebug.archive': 'Archive',
  'city.rigDebug.archivePose': 'Positionsvorführung: Siehe wie {name} Bewegungen',
  'city.pose.open': 'Schauen Sie, wie. {name} Bewegungen',
  'city.pose.robot': 'Sie (Roboter-Stand-in)',
  'city.pose.you': 'Du ...',
  'city.pose.see': 'Siehst du, wie sie sich bewegen?',
  'city.pose.youTitle': 'Wie du dich bewegst',
  'city.pose.openYou': 'Schauen Sie, wie Sie sich bewegen.',
  'city.pose.title': 'Wie? {name} Bewegungen',
  'city.pose.allTitle': 'Alle Posen',
  'city.pose.all': 'Zeigen Sie alle Posen',
  'city.pose.one': '- Ich weiß nicht . {name}',
  'city.pose.close': 'Schließen',
  'city.pose.hint': 'Tippen Sie nach außen, um zu schließen.',
  'city.pose.loading': 'Verladung',
  'city.pose.anim.idle': 'Untätig',
  'city.pose.anim.walk': 'Gehen Sie',
  'city.pose.anim.talk': 'Sprechen Sie .',
  'city.pose.anim.sit': 'Setzen Sie sich .',
  'city.pose.anim.run': 'Lauf !',
  'city.pose.drag': 'Ziehen und Drehen',
  'city.pose.gait': 'Bewegung',
  'city.pose.model': '{name} in 3D',
  'city.pose.dir.SW': 'Richtung Südwesten',
  'city.pose.dir.SE': 'Richtung Südosten',
  'city.pose.dir.NE': 'Richtung Nordosten',
  'city.pose.dir.NW': 'Richtung Nordwesten',
  'city.demoLink': 'Öffnen Sie die Render Demo',
  'city.demoTitle': 'Verleiher-Demo',
  'city.demoNote': 'Eine lokale Vorschau der 3D-Stadt mit Stand-in-Walkern.',
  'city.demoTime': 'Zeit des Tages',
  'city.demoSeason': 'Saison',
  'city.demoPlay': 'Führen Sie die Uhr',
  'city.demoPause': 'Haltet die Uhr auf .',
  'city.demoTower': 'Testturm',
  'city.demoTowerNote': 'Ein vierstöckiges Gebäude, in dem man überprüfen kann, was man im Inneren sieht.',
  'city.demoGoTower': 'Gehen Sie zum Turm.',
  'city.demoFloor': 'Boden: {floor}',
  'city.demoFloor0': 'Boden',
  'city.demoFloor1': 'Zweiter',
  'city.demoFloor2': 'Der dritte',
  'city.demoFloor3': 'Vierte',
  'city.demoFloor4': 'Dach',
  'city.demoWindow': 'Fenster im dritten Stock.',
  'city.demoRoom': 'Innenraum im dritten Stock',
  'city.demoUp': 'Auf einen Stock.',
  'city.demoDown': 'Ein Boden runter .',
  'city.makeWay.polite': 'Oh, entschuldigen Sie mich.',
  'city.makeWay.gruff': 'Pass auf, wo du fährst.',
  'city.makeWay.immovable': 'Ich bewege mich nicht.',
  'city.makeWay.busy': 'Pass auf den Weg auf.',
  'cascade.seoTitle': 'Cascade Debugger',
  'cascade.title': 'Cascade Debugger',
  'cascade.intro': 'Jeder Prompts, der die Gestalt generiert Kunst, als zwei Stammbäume. Die Stilseite läuft vom System bis zum Kunstdirektor. Die Erbseite ist die gesamte Taxonomie, von jedem Splitterwurzel bis zu den Arten und den Abstammungen, die auf ihnen sitzen. Öffnen Sie jede Zeile, um den vollständigen Text zu lesen.',
  'cascade.readOnly': 'Nichts auf diesem Bildschirm kann eine Anforderung ändern.',
  'cascade.fetchedAt': 'Lesen Sie aus der Inhalts-API in {time}',
  'cascade.refresh': 'Lesen Sie nochmal .',
  'cascade.loading': 'Lesen Sie beide Kaskaden...',
  'cascade.error': 'Ich konnte die Kaskaden nicht lesen.',
  'cascade.forbidden': 'Dieser Bildschirm ist für Website-Administratoren. Ihr Konto ist eingeloggt, hat aber keine Admin-Rolle.',
  'cascade.style.title': 'Stilkaskade',
  'cascade.style.subtitle': 'System, Verlag, Produktlinie, Einstellung, Medienart, Buch- und Kunstdirektor. Jede Zeile erbt aus den breiteren Zeilen über sich.',
  'cascade.style.focus': 'Folgen Sie der Kette für',
  'cascade.style.counts': '{nodes} Stilreihen, {edges} Verbindungen, {media} Medienvorlagen',
  'cascade.taxa.title': 'Erbfall der Erben',
  'cascade.taxa.subtitle': 'Jeder Knoten fügt seinen eigenen Anruf zu allem hinzu, was er von den Knoten über ihm erbt.',
  'cascade.taxa.group': 'Schnellgruppe',
  'cascade.taxa.find': 'Finden Sie ein Taxon oder eine Abstammung',
  'cascade.taxa.findPlaceholder': 'Homo, Terrana, ein Stammnamen...',
  'cascade.taxa.counts': '{taxa} Taxa, {prompts} Taxonprompts, {lineages} Linien',
  'cascade.taxa.shardCounts': '{taxa} Taxa, {prompts} Promptszeilen',
  'cascade.taxa.truncated': 'Die Inhalts-API hat die Anforderungsliste dieses Schnitts beschränkt, also fehlen hier vielleicht einige Zeilen.',
  'cascade.taxa.emptyShards': 'Scherben ohne Taxa noch: {names}',
  'cascade.taxa.orphans': 'Linie, die auf einen Taxon hinweisen, der nicht in einem Baum ist',
  'cascade.taxa.noOwn': 'Für diese Gruppe gibt es keinen eigenen Anruf.',
  'cascade.taxa.inherits': 'Erbschaften von oben',
  'cascade.taxa.inheritsNothing': 'Hier beginnt die Kette.',
  'cascade.taxa.through': 'Durch diesen Knoten zusammengesetzt',
  'cascade.taxa.lineages': 'Linie auf dieser Art',
  'cascade.level.system': 'System',
  'cascade.level.publisher': 'Verlag',
  'cascade.level.product_line': 'Produktlinie',
  'cascade.level.setting': 'Einstellung',
  'cascade.level.media': 'Medienart',
  'cascade.level.book': 'Buch',
  'cascade.level.art_director': 'Kunstdirektor',
  'cascade.empty.system': 'Keine System-Stil-Reihe auf dieser Kette.',
  'cascade.empty.publisher': 'Es gibt noch keine Verleger-Stil-Reihe.',
  'cascade.empty.product_line': 'Keine Produktlinie-Stilreihe in dieser Kette.',
  'cascade.empty.setting': 'Keine Stilreihen auf dieser Kette.',
  'cascade.empty.media': 'Für diese Kette gelten keine Vorlagen des Medientyps.',
  'cascade.empty.book': 'Keine Zeile im Buchstil hängt von dieser Einstellung ab.',
  'cascade.empty.art_director': 'Kein Kunstdirektor ist mit dieser Kette verbunden.',
  'cascade.missing': 'Fehlende Stufe',
  'cascade.others': 'Andere Zeilen auf dieser Ebene ({count})',
  'cascade.mediaSpeciesNote': '{count} die Artenvorlagen sind auf der Erbseite unter ihrer Abstammung angezeigt.',
  'cascade.field.id': 'Ausweis',
  'cascade.field.scope': 'Anwendungsbereich',
  'cascade.field.scopeId': 'Anwendungsbereich',
  'cascade.field.group': 'Gruppe',
  'cascade.field.mediaType': 'Medientyp',
  'cascade.field.prompt': 'Schnell',
  'cascade.field.negative': 'negative',
  'cascade.field.defaults': 'Vergütungen',
  'cascade.field.refs': 'Referenzbilder',
  'cascade.field.chars': '{count} Charaktere',
  'cascade.field.empty': 'leere',
  'cascade.facet.art_direction': 'Kern',
  'cascade.facet.art_direction_character': 'Charakter',
  'cascade.facet.art_direction_scene': 'Die Szene',
  'cascade.facet.art_direction_interface': 'Schnittstelle',
  'cascade.facet.art_direction_cartography': 'Kartographie',
  'cascade.facet.art_direction_audiobook': 'Hörbuch',
  'cascade.facet.art_direction_movie': 'Film',
  'cascade.facet.art_direction_short': 'Kurz',
  'cascade.facet.art_direction_tvshow': 'Fernsehsendung',
  'cascade.composed.title': 'Zusammengesetzt für {name}',
  'cascade.composed.layers': 'Schichten, von breit bis schmal',
  'cascade.composed.preview': 'Zusammengestellte Bild-Anforderung',
  'cascade.composed.previewNote': 'Auf diesem Bildschirm aus den oben genannten Zeilen in Kaskadenfolge zusammengestellt: Stilkern, Zeichenfasz, Medienvorlagen, Taxon-Zeichen, dann die Druckzeile, die der Generator in Code hinzufügt.',
  'cascade.composed.negative': 'Zusammengesetztes Negativ',
  'cascade.composed.fromCode': 'in einem Code hinzugefügt, nicht in einer Zeile gespeichert',
  'cascade.flags.duplicates': 'Ich habe es zweimal gesagt.',
  'cascade.flags.conflicts': 'Negative Begriffe, die auch in der Anforderung erscheinen',
  'cascade.flags.none': 'Keine wiederholten Sätze und keine negativen Begriffe, die mit dem Anruf in Konflikt stehen.',
  'cascade.flags.in': 'in {sources}',
  'cascade.source.styleCore': 'Stil Kern',
  'cascade.source.styleCharacter': 'Stil-Charakter-Faschte',
  'cascade.source.media': 'Medienvorlage, {scope}',
  'cascade.source.taxon': 'Taxon {rank} {value}',
  'cascade.source.printSafe': 'Schriftlinie (Code)',
  'cascade.rank.domain': 'Domäne',
  'cascade.rank.kingdom': 'Königreich',
  'cascade.rank.phylum': 'Phylum',
  'cascade.rank.class': 'Klasse',
  'cascade.rank.ordem': 'Ordnung',
  'cascade.rank.family': 'Familie',
  'cascade.rank.genus': 'Genus',
  'cascade.rank.species': 'Arten',
  'cascade.rank.shard': 'Schüttel',
}
